// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"ba8841bf","828":"e6543b41","963":"2d65e9a1","967":"2314fa7e"}[chunkId] + ".chunk.js";
};